import styled from 'styled-components';

const Text = styled.p`
  font-size: 14px;
  padding-bottom: 24px;
  text-transform: none;
`;

const HintBox = styled.div`
  display: flex;
  justify-content: space-between;
`;

const FormTitle = styled.span`
  display: flex;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 120%;
  color: #282828;
  margin-bottom: 8px;
  text-transform: ${({ theme }) => theme.titleTransform};
`;

const Wrapper = styled.div`
  width: 100%;
  margin: 0 auto 0;
  max-width: 720px;
`;

export { Wrapper, FormTitle, HintBox, Text };
